import React, { useContext } from 'react'
import { ReducerContext } from '../reducers/reducerContext.js';
import Details from '../components/results/Details'

export default function ContDetails() {
  const globalstate = useContext(ReducerContext);

  return (
    <Details
      context={globalstate.testCriteria.context}
      vehicleDetails={globalstate.responseSimulation.vehicleDetails}
      settings={globalstate.settings}
      vehicle={globalstate.responseSimulation.selectedVehicle}
    />
  );
}
